import { Component } from "@angular/core";

@Component({
  selector: "app-replacement-claim-overview-open",
  templateUrl: "./replacement-claim-overview-open.component.html",
  styleUrls: ["./replacement-claim-overview-open.component.less"],
})
export class ReplacementClaimOverviewOpenComponent {}
